import store from '@/store/index'
import { pushEvent } from '@/common/cmm-trace'
import NProgress from 'nprogress'
import RouterHistory from '@/common/router-history'

export default function afterEach(to, from) {
  NProgress.done()
  store.dispatch('route/after', { to, from })
  store.dispatch('route/loadingBefore', false)
  RouterHistory.pushPage(to)
  try {
    const url = to.path
    pushEvent('baidu_pv', { url })
    // eslint-disable-next-line no-undef
    _hmt && _hmt.push(['_trackPageview', url])
  } catch (e) {
    console.log(e)
  }
}
